export default __webpack_public_path__ + "static/media/vdt-splash-screen.e0992b30.webp";